/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriceListCreateApiModel { 
    name: string;
    validityStart: string;
    validityEnd?: string | null;
    employerId: number;
    copyPriceListId?: number | null;
}

